export function GatePassTable({
    passes = [],
    loading = false,
    onPageChange = () => {},
    onSearch = () => {},
    currentPage = 1,
    totalPages = 1,
    searchQuery = "",
    onSearchChange = () => { },
    onPassClick= () => { },
  }) {
    const getStatusBadgeClass = (status) => {
      const baseClasses = "px-3 py-1 rounded-full text-sm font-medium";
      switch (status.toLowerCase()) {
        case "approved":
          return `${baseClasses} bg-green-100 text-green-700`;
        case "pending":
          return `${baseClasses} bg-yellow-100 text-yellow-700`;
        case "expired":
          return `${baseClasses} bg-red-100 text-red-700`;
        default:
          return `${baseClasses} bg-gray-100 text-gray-700`;
      }
    };

    if (loading) {
      return (
        <div className="bg-white rounded-xl shadow-md p-6 w-9/12">
          <div className="animate-pulse space-y-4">
            <div className="h-10 bg-gray-200 rounded w-1/4"></div>
            <div className="space-y-3">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="h-20 bg-gray-200 rounded"></div>
              ))}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="bg-white rounded-xl shadow-md">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">
                  Pass ID
                </th>

                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">
                  Visit Date
                </th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">
                  Purpose
                </th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">
                  Persons
                </th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">
                  Vehicle Number
                </th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">
                  Arrival Time
                </th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">
                  Valid Till
                </th>
                <th className="px-6 py-4 text-right text-sm font-semibold text-gray-600">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {passes.map((pass) => (
                <tr key={pass.id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4">
                    <span className="font-medium text-gray-900">#{pass.id}</span>
                  </td>

                  <td className="px-6 py-4">
                    <div className="text-gray-900">
                      {new Date(pass.visit_date).toLocaleDateString()}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-gray-900">{pass.purpose}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-gray-900">{pass.tot_person}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-gray-900">{pass.vehicle_num}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-gray-900">{pass.arrival_time}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-gray-900">
                      {new Date(pass.valid_till).toLocaleString()}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex justify-end gap-2">
                      <button
                        className="text-blue-600 hover:text-blue-700 font-medium"
                        onClick={() => onPassClick(pass)}
                      >
                        <i className="fas fa-eye mr-1"></i>
                        View
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {passes.length === 0 && (
            <div className="text-center py-12">
              <div className="text-gray-500">No passes found</div>
            </div>
          )}
        </div>

        <div className="px-6 py-4 border-t border-gray-100">
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-500">
              Showing page {currentPage} of {totalPages}
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-4 py-2 border border-gray-200 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
              >
                Previous
              </button>
              <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-4 py-2 border border-gray-200 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }




